import React, { createContext, useContext, useState, useEffect } from 'react';
import { authAPI } from '../utils/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('netstock_token');
    const stored = localStorage.getItem('netstock_user');
    if (token && stored && stored !== 'undefined') {
      try {
        setUser(JSON.parse(stored));
      } catch(e) {
        localStorage.removeItem('netstock_token');
        localStorage.removeItem('netstock_user');
        setLoading(false);
        return;
      }
      // Vérifier que le token est encore valide
      authAPI.me()
        .then(r => { setUser(r.data); localStorage.setItem('netstock_user', JSON.stringify(r.data)); })
        .catch(() => logout())
        .finally(() => setLoading(false));
    } else {
      localStorage.removeItem('netstock_token');
      localStorage.removeItem('netstock_user');
      setLoading(false);
    }
  }, []);

  const login = (token, userData) => {
    localStorage.setItem('netstock_token', token);
    localStorage.setItem('netstock_user', JSON.stringify(userData));
    setUser(userData);
  };

  const logout = () => {
    localStorage.removeItem('netstock_token');
    localStorage.removeItem('netstock_user');
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, loading, isAdmin: user?.role === 'admin' }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
